(function (){
    'use strict';

    angular
        .module('services')
        .service('StatisticsService', StatisticsService);

    StatisticsService.$inject = ['$http', 'API_BASE'];

    function StatisticsService ($http, API_BASE) {
        var service = this;

        service.getAllExpos = getAllExpos
        service.getExpoStats = getExpoStats

        function getExpoStats(id) {
            return $http.get(API_BASE + `/virtualfairs/fair/${id}/stats`);
        }

        function getAllExpos(query) {
            return $http.get(API_BASE + "/virtualfairs/list", { params: query });
        }

    }
})();